import { IPostbackSendFormLang } from '../../../types/lang'

export const postbackSendFormLang: IPostbackSendFormLang = {
	postback_send_form: {
		field_sub_id_label: 'Sub Id_ru',
		field_sub_id_placeholder: 'Insert or enter options..._ru',
		field_postback_status_label: 'Postback Status_ru',
		field_postback_status_placeholder: 'Postback Status_ru',
		field_postback_currency_label: 'Currency_ru',
		field_postback_currency_placeholder: 'Currency_ru',
		field_postback_amount_label: 'Amount_ru',
		field_postback_amount_placeholder: 'Type number_ru',
		msg_postback_send_success: 'Postback sent successfully!_ru',
		msg_postback_send_error: 'Postback send error!_ru',
		btn_send: 'Send_ru'
	}
}